import { createApp } from 'vue';
import FeedPicker from "./components/layout/FeedPicker.vue";
import './scss/main.scss';

const components = {
    'feed-picker': FeedPicker,
};

Object.entries(components).forEach(([name, component]) => {
    const el = document.querySelector(`[data-vue-component="${name}"]`);
    if (el) {
        const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
        el.removeAttribute('data-props');
        createApp(component, props).mount(el);
    }
})
